/**
 * Convert a string to dash separated words.
 * @function
 * @param {string} str
 * @return {string} kebab formatted string.
 */
export default function kebab(str) {
  return str.toLowerCase().trim().replace(/[^a-z|\s|0-9|_]/g, '').replace(/_/g, '-').replace(/\s+/g, '-');
}